/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import NProgress from 'nprogress';
import Backbone from 'backbone';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { getUserDetails, userHasRole } from '@/util/RoleUtils';
import ErrorView from '@/views/ErrorView';

import GetOrderPackage from '../services/GetOrderPackage';
import OrderPackagePrintPage from '../pages/OrderPackagePrintPage';

export default async function ShowOrderPackagePage(orderPackageID, activeSectionId, editMode) {
    NProgress.start();

    try {
        if (userHasRole('CRS') || userHasRole('EPC') || userHasRole('Admin')) {
            orderPackageID = parseInt(orderPackageID);
            NavUtils.navigate(`order-package/${orderPackageID}/print`);
        } else {
            showErrorView();
            return;
        }

        const orderPackage = await GetOrderPackage(orderPackageID);

        if (!orderPackage?.id) {
            throw new Error('Not Found');
        }

        const isCRSOwner = orderPackage?.crsInternalUserID === getUserDetails()?.id;
        const isEPCOwner = orderPackage?.epcInternalUserID === getUserDetails()?.id;
        Scaffold.getRegion('content').show(
            new OrderPackagePrintPage({
                activeSectionId,
                orderPackageID,
                isCRSOwner,
                isEPCOwner,
                model: new Backbone.Model({
                    orderPackage
                })
            })
        );
    } catch (err) {
        Scaffold.getRegion('content').show(
            new ErrorView({
              model: new Backbone.Model({
                errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
                errorDetails: 'Something went wrong while loading the Print Order Package page.'
              })
            })
          );
    } finally {
        NProgress.done();
    }
}

function showErrorView(err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
          errorDetails: 'Your account may not have permission to view the Print Order Package page.'
        })
      })
    );
  }